import classNames from 'classnames'

import BlockWrapper from './block_wrapper'

import styles from './divider.module.sass'

function Divider(props) {
	const spacingStyles = {}

	if (props.fields.top_margin) {
		spacingStyles.marginTop = props.fields.top_margin + 'px'
	}

	return <BlockWrapper {...props} className={classNames(styles.divider)}>
		<div style={spacingStyles}></div>
	</BlockWrapper>
}

export default Divider